import React from "react";
import { Snackbar, Alert, Slide } from "../../styles/MaterialUI";

const CustomToasts = ({ toastInfo, onClose }) => {
  return (
    <>
      <Snackbar
        key={toastInfo.message}
        open={toastInfo.isOpen}
        autoHideDuration={3000}
        onClose={() => onClose()}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={(props) => <Slide {...props} direction="down" />}
      >
        <Alert variant="filled" severity={toastInfo.severity} onClose={() => onClose()}>
          {toastInfo.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CustomToasts;
